import React from 'react';
import { EarningsListPage } from './list';

export const EarningsModule = () => {
  return <EarningsListPage />;
};
